import * as AppConstants from 'app/AppConstants';
import {fetchPollById, saveVote} from './pollService';

export const loadPollById = cardId => dispatch =>
  fetchPollById(cardId).then(result => {
    dispatch({
      type: AppConstants.POLL__LOADED,
      payload: {
        cardId,
        poll: result,
      },
    });
  });

export const vote = (cardId, votes) => dispatch =>
  saveVote(cardId, votes).then(response => {
    dispatch({
      type: AppConstants.POLL__VOTED,
      payload: {
        cardId,
        votes,
        poll: response,
      },
    });
  });
